<main *ngIf="listDevice">

  <ng-container *ngIf="enable">


    <button mat-raised-button *ngIf="selectedOptions != listDevice" (click)="selectedAllOptions()">{{'selectedAll' | translation}}</button>
    <button mat-raised-button *ngIf="selectedOptions == listDevice" (click)="selectedOptions = null">{{'unselectAll' | translation}}</button>
  </ng-container>
  <mat-selection-list [(ngModel)]="selectedOptions" #devices>
    <mat-list-option *ngFor="let device of listDevice" [value]="device">
      {{device.data.name}}
    </mat-list-option>
  </mat-selection-list>

  <div mat-dialog-actions>
    <button mat-raised-button (click)="setSelectedDevice(devices.selectedOptions.selected)" color="primary">OK</button>
    <button mat-raised-button (click)="setSelectedDevice(null)" color="warn">{{'cancel' | translation}}</button>
  </div>
</main>
